// extracted by mini-css-extract-plugin
export default {"root":"PlasmicGraphStack_root__tVwIY"};